export const VOICE_API_URL = process.env.VUE_APP_VOICE_API_URL || 'http://localhost:8642'
